"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogicalExpression = exports.LogicalOperator = void 0;
const utils_1 = require("./utils");
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["GreaterThan"] = ">";
    LogicalOperator["LessThan"] = "<";
    LogicalOperator["GreaterThanEqual"] = ">=";
    LogicalOperator["LessThanEqual"] = "<=";
    LogicalOperator["Equals"] = "==";
    LogicalOperator["NotEquals"] = "!=";
    LogicalOperator["Else"] = "else";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
class LogicalExpression {
    constructor(initObj) {
        this.leftOperand = initObj.leftOperand;
        this.rightOperand = initObj.rightOperand;
        this.operator = initObj.operator;
    }
    validate(extras) {
        const leftOperandVal = utils_1.castToPrimitive(extras.store.getFromRefVal(this.leftOperand));
        const rightOperandVal = utils_1.castToPrimitive(extras.store.getFromRefVal(this.rightOperand));
        switch (this.operator) {
            case LogicalOperator.GreaterThan:
                return leftOperandVal > rightOperandVal;
            case LogicalOperator.GreaterThanEqual:
                return leftOperandVal >= rightOperandVal;
            case LogicalOperator.LessThan:
                return leftOperandVal < rightOperandVal;
            case LogicalOperator.LessThanEqual:
                return leftOperandVal <= rightOperandVal;
            case LogicalOperator.Equals:
                return leftOperandVal == rightOperandVal;
            case LogicalOperator.NotEquals:
                return leftOperandVal != rightOperandVal;
            case LogicalOperator.Else:
            default:
                return true;
        }
    }
}
exports.LogicalExpression = LogicalExpression;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9naWNhbEV4cHJlc3Npb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL0xvZ2ljYWxFeHByZXNzaW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLG1DQUEwQztBQUUxQyxJQUFZLGVBUVg7QUFSRCxXQUFZLGVBQWU7SUFDekIsb0NBQWlCLENBQUE7SUFDakIsaUNBQWMsQ0FBQTtJQUNkLDBDQUF1QixDQUFBO0lBQ3ZCLHVDQUFvQixDQUFBO0lBQ3BCLGdDQUFhLENBQUE7SUFDYixtQ0FBZ0IsQ0FBQTtJQUNoQixnQ0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQVJXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBUTFCO0FBRUQsTUFBYSxpQkFBaUI7SUFJNUIsWUFBWSxPQUFvQjtRQUM5QixJQUFJLENBQUMsV0FBVyxHQUFHLE9BQU8sQ0FBQyxXQUFXLENBQUM7UUFDdkMsSUFBSSxDQUFDLFlBQVksR0FBRyxPQUFPLENBQUMsWUFBWSxDQUFDO1FBQ3pDLElBQUksQ0FBQyxRQUFRLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQztJQUNuQyxDQUFDO0lBQ0QsUUFBUSxDQUFDLE1BQWM7UUFDckIsTUFBTSxjQUFjLEdBQUcsdUJBQWUsQ0FDcEMsTUFBTSxDQUFDLEtBQUssQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUM3QyxDQUFDO1FBQ0YsTUFBTSxlQUFlLEdBQUcsdUJBQWUsQ0FDckMsTUFBTSxDQUFDLEtBQUssQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUM5QyxDQUFDO1FBQ0YsUUFBUSxJQUFJLENBQUMsUUFBUSxFQUFFO1lBQ3JCLEtBQUssZUFBZSxDQUFDLFdBQVc7Z0JBQzlCLE9BQU8sY0FBYyxHQUFHLGVBQWUsQ0FBQztZQUMxQyxLQUFLLGVBQWUsQ0FBQyxnQkFBZ0I7Z0JBQ25DLE9BQU8sY0FBYyxJQUFJLGVBQWUsQ0FBQztZQUMzQyxLQUFLLGVBQWUsQ0FBQyxRQUFRO2dCQUMzQixPQUFPLGNBQWMsR0FBRyxlQUFlLENBQUM7WUFDMUMsS0FBSyxlQUFlLENBQUMsYUFBYTtnQkFDaEMsT0FBTyxjQUFjLElBQUksZUFBZSxDQUFDO1lBQzNDLEtBQUssZUFBZSxDQUFDLE1BQU07Z0JBQ3pCLE9BQU8sY0FBYyxJQUFJLGVBQWUsQ0FBQztZQUMzQyxLQUFLLGVBQWUsQ0FBQyxTQUFTO2dCQUM1QixPQUFPLGNBQWMsSUFBSSxlQUFlLENBQUM7WUFDM0MsS0FBSyxlQUFlLENBQUMsSUFBSSxDQUFDO1lBQzFCO2dCQUNFLE9BQU8sSUFBSSxDQUFDO1NBQ2Y7SUFDSCxDQUFDO0NBQ0Y7QUFsQ0QsOENBa0NDIn0=